"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuditGet = void 0;
const index_1 = require("../../ui/hooks/index");
const swr_1 = __importDefault(require("swr"));
/**
 * Hook to fetch audit information by ID using SWR for data fetching and caching.
 *
 * This hook utilizes the `useAuditClient` to create an audit client and fetches audit data by ID
 * using the `useSWR` hook. It optionally accepts a base URL for the audit service, a token provider
 * for authentication, and additional configuration for SWR.
 *
 * @param id - The ID of the audit to fetch.
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object
 * @returns {SWRResponse<GetAuditResponse, unknown>} The SWR response object containing the audit data, loading state, and error information.
 */
function useAuditGet(id, baseUrl, tokenProvider, config) {
    const auditClient = (0, index_1.useAuditClient)(baseUrl, tokenProvider);
    return (0, swr_1.default)([`/platform/audit/getById`, id], (_a) => __awaiter(this, [_a], void 0, function* ([, id]) {
        return yield auditClient.get({ id: id });
    }), config !== null && config !== void 0 ? config : {
        revalidateOnFocus: false,
    });
}
exports.useAuditGet = useAuditGet;
